// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import FeaturesHighClass from '../_raw/features/icon_features_high_class.svg';
import withIconProps from '../withIconProps';

export default withIconProps(FeaturesHighClass, { shouldSetDefaultSize: false });
